import { Typography } from "@mui/material";
import { FC } from "react";

interface MissionDateColumnProps {
  missionDate?: string;
}

const MissionDateColumn: FC<MissionDateColumnProps> = ({ missionDate }) => {
  if (missionDate) {
    return <Typography>{new Date(missionDate).toLocaleString("fr-FR")}</Typography>;
  }

  return <Typography>-</Typography>;
};

export default MissionDateColumn;
